import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function ElectronicsEngineering() {
  return (
    <div id="top">
      <div id="wrapper">
        <Header />
        <div id="navig_inside">
          <Navigation />
        </div>
        <div id="banner"></div>
        <div id="inside_page" className="bodyText">
          <div id="page1">
            <span className="bodyText">
              <p className="welcome_heading"><strong>Electronics &amp; Communication Engineering </strong></p>
            </span><span className="bodyText">
              <div className="clear"></div>
            </span>
            <div id="apparel_right"><img src="/images/images/03.png" width="264" height="252" alt="Electronics Engineering" /></div>
            <div id="apparel">
              <ul className="apparel">
                <li>Intake of 27 students.</li>
                <li>Well-equipped laboratories like Power Electronics &amp; PLC, Advanced Microprocessors, VLSI, Analog Electronic Circuits, Digital Electronics, Microcontrollers, Basic Electronics Lab etc.</li>
                <li>Qualified and dedicated staff.</li>
                <li>Free Internet facility for all students (with Digital Library facility).</li>
                <li>Regular Industrial visits and Internships for practical exposure.</li>
                <li>Innovation Centre/Tinkering Lab facility.</li>
              </ul>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default ElectronicsEngineering;
